import { deleteEmptyObj } from '@/utils/utils'
import { isObject } from 'lodash'

const state = {
  courseManageGetData: {},
  courseInfo: {},
  allScreen: false,
  page: 1,
  total: 0,
  limit: 8,
  showCreateModal: false,
  showListModal: false,
  showDetailModal: false,
  growthFileClassList: [], // 成长档案班级列表数据
  class_id: '',
  classOption: [],
  value: 5, // 新增、编辑成长档案综合评价维度评分
  value1: 5,
  value2: 5,
  value3: 5,
  value4: 5,
  value5: 5,
  understand: 3, // 知识理解
  basic: 3, // 基础应用
  complex: 3, // 综合应用
  selectLessons: [], // 选中的作品
  addIndex: '', // 点击下一份保存当前点击的index
  teachingCmdMap: {} // 记录教室执行过的指令集合
}

const actions = {
  // 检测是否有成长档案模板
  async checkGrowthFile ({ state }, lessonId) {
    const res = await API.post(`/edu/zone/growth/${lessonId}/check`)
    return res
  },
  // 获取班级成长档案
  async growthFileGetData ({ state }, payload) {
    const res = await API.get(
      `/edu/zone/growth/lesson/class/profile?lesson_id=${payload}&class_id=${state.class_id}`
    )
    return res
  },
  // 获取班级下拉列表
  async growthFileGetClassOption ({ commit, rootState }) {
    const unit_id = rootState.user.role_id
    if (unit_id === 40001) {
      const res = await API.get('/edu/zone/channel/agent/class/simple')
      return res
    } else {
      const res = await API.get('/edu/zone/classes/simple')
      return res
    }
  },
  // 新增、编辑成长档案
  async createGrowthFile ({ state }, payload) {
    const params = {
      account_id: payload.account_id,
      lesson_id: sessionStorage.getItem('lessonID'),
      personal_assess_info: [
        {
          type: '1',
          value: state.value
        },
        {
          type: '2',
          value: state.value1
        },
        {
          type: '3',
          value: state.value2
        },
        {
          type: '4',
          value: state.value3
        },
        {
          type: '5',
          value: state.value4
        },
        {
          type: '6',
          value: state.value5
        }
      ],
      profile_url: payload.profile_url,
      remark: payload.remark,
      target_finish_level_info: [
        {
          type: 1,
          value: state.understand + 1
        },
        {
          type: 2,
          value: state.basic + 1
        },
        {
          type: 3,
          value: state.complex + 1
        }
      ],
      work_ids: state.selectLessons.map(row => row.id)
    }
    deleteEmptyObj(params)
    const res = await API.post(`/edu/zone/growth/student/profile/save`, params)
    return res
  },
  // 成长档案图片上传成功后更新数据库字段
  async updateGrowthFile ({ state }, payload) {
    const params = {
      account_id: payload.account_id,
      lesson_id: sessionStorage.getItem('lessonID'),
      profile_url: payload.profile_url,
      remark: payload.remark
    }
    const res = await API.post(`/edu/zone/growth/student/profile/save`, params)
    return res
  },
  // 新增成长档案选择本节课作品
  async selectLessons ({ state }, payload) {
    const res = await API.post(
      `/edu/zone/growth/student/work/list?page=${state.page}&limit=${state.limit}`,
      payload
    )
    return res
  },
  // 查看成长档案
  async viewGrowthFile ({ state }, payload) {
    const res = await API.post(
      `/edu/zone/growth/student/profile/${payload}/view`
    )
    return res
  },
  // 删除学生成长档案
  async deleteGrowthFile ({ state }, payload) {
    const res = await API.post(
      `/edu/zone/growth/student/profile/${payload}/remove`
    )
    return res
  },
  // 获取班级学生列表
  async courseManageGetStudentList ({ state }, id) {
    const res = await API.post(`/edu/zone/lesson/offical/lesson/class/${id}/students`)
    return res
  },
  // 批量给班级发送课程包
  async batchSendClassCourse ({ state }, payload) {
    const res = await API.post(`/edu/zone/lesson/offical/lesson/class/send`, payload)
    return res
  },
  // 批量给学生发送课程包
  async batchSendStudentCourse ({ state }, payload) {
    const res = await API.post(`/edu/zone/lesson/offical/lesson/student/send`, payload)
    return res
  },
  // 批量给班级发送课程资料
  async batchSendClassCourseData ({ state }, payload) {
    const res = await API.post(`/edu/zone/lesson/${payload.type}/lesson/class/send/resource`, payload.data)
    return res
  },
  // 批量给学生发送课程资料
  async batchSendStudentCourseData ({ state }, payload) {
    const res = await API.post(`/edu/zone/lesson/${payload.type}/lesson/student/send/resource`, payload.data)
    return res
  },
  // 获取列表数据
  async getCourseList ({ state }, id) {
    const res = await API.get(`/edu/zone/lesson/offical/lessons`, { page: 1, package_id: id, limit: 100 })
    return res
  },
  // 获取课包信息
  async getPackageInfo(_, obj) {
    let packageId = ''
    let topicId = ''
    if (isObject(obj)) {
      packageId = obj.id
      topicId = obj.topicId
    } else {
      packageId = obj
    }
    const topicInfoList = sessionStorage.getItem('topicInfoList')
    const res = await API.get(`/edu/zone/lesson/offical/packages/${packageId}`, { topicId, topicInfoList })
    return res
  },
  // 获取栏目信息
  async getTopicInfo(_, topicId) {
    const res = await API.get(`/edu/zone/lessons/official/packages/topic/info`, { topicId })
    return res
  },
  // 获取课程列表
  async getLessonList ({ state }, id) {
    const res = await API.get(`/edu/zone/lesson/offical/package/lesson/list?package_id=${id}`)
    return res
  },
  // 获取班级列表
  async getClassList ({ state }) {
    const res = await API.get(`/edu/zone/lesson/offical/class`)
    return res
  },
  // 申请开通课程
  async applyOpenPackage ({ state }, payload) {
    const res = await API.post(`/edu/zone/lessons/package/open/applicant`, payload)
    return res
  },
  // 获取课程开通状态
  async getPackageType ({ state }, payload) {
    const res = await API.get(`/edu/zone/lessons/package/open/check`, payload)
    return res
  },
  // 获取用户手机号
  async getUserPhone ({ state }) {
    // const res = await API.get(`/edu/zone/user/phone`)
    // return res
  },
  // 将课程添加到“我的课程”
  async addCourseToUser({ state }, payload) {
    const res = await API.post(`/edu/zone/lesson/offical/person/packages`, payload)
    return res
  }
}

const mutations = {
  growthFileInit (state) {
    state.page = 1
    state.limit = 8
    state.class_id = ''
    state.classOption = []
    state.value = 5
    state.value1 = 5
    state.value2 = 5
    state.value3 = 5
    state.value4 = 5
    state.value5 = 5
    state.understand = 3
    state.basic = 3
    state.complex = 3
    state.selectLessons = []
    state.addIndex = ''
  },
  setTeachingCmdMap(state, key) {
    if (key === 'clear') {
      state.teachingCmdMap = {}
    } else {
      state.teachingCmdMap[key] = true
    }
  }
}

export default {
  state,
  actions,
  mutations
}
